<script setup lang="ts">
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { computed } from 'vue';
import {type IconName, icons} from '@/ui/icon/icons';

// Define props
// normal = black
// inverted = white
// info = blue
// success = green
// gray = ??
const props = withDefaults(defineProps<{
    icon: IconName,
    color?: 'white' | 'black' | 'blue' | 'green' | 'gray', // Add color prop with type
    size?: 'small' | 'medium', // Update size prop with new options
}>(), {
    color: 'black',
    size: 'medium',
});

const selectedIcon = computed(() => {
    if (props.icon && icons[props.icon]) {
        return icons[props.icon];
    }

    return null;
});

// Compute inverse property based on color prop
const isInverse = computed(() => {
    return props.color === 'white';
});

// Add style for blue color
const iconStyle = computed(() => {
    const style: Record<string, string> = {};

    if (props.color === 'blue') {
        style.color = '#2D76F6';
    }

    if (props.color === 'green') {
        style.color = '#58A96D';
    }

    if (props.color === 'gray') {
        style.color = '#E5E5E5';
        style.backgroundColor = '#fff';
    }

    // Add size in pixels
    style.fontSize = props.size === 'small' ? '16px' : '21px';
    style.backgroundColor = 'inherit';

    return style;
});



</script>

<template>
    <template v-if="selectedIcon">
        <FontAwesomeIcon
            :icon="selectedIcon"
            :inverse="isInverse"
            :style="iconStyle"
        />
    </template>
    <span v-else>Icon not found</span>
</template>
